import React from "react";
import "./IconModification.css";

const DesktopIcon = () => {
  return (
    <div>
      <svg
        className="Icons"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        id="desktop"
        x="px"
        y="0px"
        viewBox="0 0 240 212"
        enableBackground="new 0 0 240 212"
        width="120px"
        height="120px"
      >
        <g>
          <path
            fill="#D0E8FF"
            d="M76,136.1777h60v-76H12v76h56H76z M54.8281,75.0059l-24,24c-0.7812,0.7812-1.8047,1.1719-2.8281,1.1719   s-2.0469-0.3906-2.8281-1.1719c-1.5625-1.5625-1.5625-4.0938,0-5.6562l24-24c1.5625-1.5625,4.0938-1.5625,5.6562,0   S56.3906,73.4434,54.8281,75.0059z"
          />
          <circle fill="#1C71DA" cx="196" cy="96.1777" r="4" />
          <path
            fill="#5CB0FF"
            d="M160,24.1777v144h56v-144H160z M196,108.1777c-6.6172,0-12-5.3828-12-12s5.3828-12,12-12s12,5.3828,12,12   S202.6172,108.1777,196,108.1777z M208,44.1777h-40v-8h40V44.1777z"
          />
          <path
            fill="#1C71DA"
            d="M8,144.1777h60v12H52v8h40v-8H76v-12h64c2.2109,0,4-1.7891,4-4v-84c0-2.2109-1.7891-4-4-4H8   c-2.2109,0-4,1.7891-4,4v84C4,142.3887,5.7891,144.1777,8,144.1777z M12,60.1777h124v76H76h-8H12V60.1777z"
          />
          <rect x="168" y="36.1777" fill="#1C71DA" width="40" height="8" />
          <path
            fill="#1C71DA"
            d="M196,84.1777c-6.6172,0-12,5.3828-12,12s5.3828,12,12,12s12-5.3828,12-12S202.6172,84.1777,196,84.1777z    M196,100.1777c-2.207,0-4-1.793-4-4s1.793-4,4-4s4,1.793,4,4S198.207,100.1777,196,100.1777z"
          />
          <path
            fill="#1C71DA"
            d="M49.1719,69.3496l-24,24c-1.5625,1.5625-1.5625,4.0938,0,5.6562c0.7812,0.7812,1.8047,1.1719,2.8281,1.1719   s2.0469-0.3906,2.8281-1.1719l24-24c1.5625-1.5625,1.5625-4.0938,0-5.6562S50.7344,67.7871,49.1719,69.3496z"
          />
          <path
            fill="#1C71DA"
            d="M224,168.1777v-148c0-2.2109-1.7891-4-4-4h-64c-2.2109,0-4,1.7891-4,4v148H0v8h156h64h20v-8H224z    M160,168.1777v-144h56v144H160z"
          />
        </g>
        <path
          fill="#FF5D5D"
          d="M100.252,212c-1.0234,0-2.0479-0.3906-2.8281-1.1719c-1.5625-1.5615-1.5625-4.0947,0-5.6562l14.1426-14.1416  c1.5625-1.5625,4.0957-1.5625,5.6562,0c1.5625,1.5615,1.5625,4.0947,0,5.6562l-14.1426,14.1416  C102.2988,211.6094,101.2754,212,100.252,212z"
        />
        <path
          fill="#FF5D5D"
          d="M114.3945,212c-1.0234,0-2.0469-0.3906-2.8281-1.1719l-14.1426-14.1416  c-1.5625-1.5615-1.5625-4.0947,0-5.6562c1.5605-1.5625,4.0938-1.5625,5.6562,0l14.1426,14.1416  c1.5625,1.5615,1.5625,4.0947,0,5.6562C116.4424,211.6094,115.418,212,114.3945,212z"
        />
        <path
          fill="#00D40B"
          d="M30.252,52c-7.7197,0-14-6.2803-14-14s6.2803-14,14-14s14,6.2803,14,14S37.9717,52,30.252,52z M30.252,32  c-3.3086,0-6,2.6914-6,6s2.6914,6,6,6s6-2.6914,6-6S33.5605,32,30.252,32z"
        />
        <path
          fill="#FFC504"
          d="M103.5664,30.627c-1.0234,0-2.0469-0.3906-2.8281-1.1719L89.4238,18.1416  c-0.75-0.75-1.1719-1.7676-1.1719-2.8281s0.4219-2.0781,1.1719-2.8281l11.3145-11.3135c1.5625-1.5625,4.0938-1.5625,5.6562,0  l11.3135,11.3135c1.5625,1.5615,1.5625,4.0947,0,5.6562l-11.3135,11.3135C105.6143,30.2363,104.5898,30.627,103.5664,30.627z   M97.9092,15.3135l5.6572,5.6572l5.6562-5.6572l-5.6562-5.6572L97.9092,15.3135z"
        />
      </svg>
    </div>
  );
};

export default DesktopIcon;
